// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 查询菜单列表（支持关键字搜索和分页） GET /api/menu */
export async function getApiMenu(
  // 叠加生成的Param类型
  params: {
    /** 关键字搜索 */
    Keyword?: string;
    /** 页码 */
    PageIndex?: number;
    /** 每页数量 */
    PageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<
    API.IServiceResult & {
      items?: MenuItem[];
      total?: number;
    }
  >('/api/menu', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

// 菜单项接口定义
export interface MenuItem {
  id: string;
  name: string;
  path: string;
  component?: string;
  icon?: string;
  parentId?: string;
  order?: number;
  children?: MenuItem[];
  [key: string]: any;
}

// 更新菜单输入接口定义
export interface UpdateMenuInput {
  id: string;
  name?: string;
  menuType: number;
  route?: string;
  icon?: string;
  displayOrder: number;
  permissionIdentifier?: string;
  isEnabled: boolean;
  parentId?: string;
}

/** 更新菜单 PUT /api/menu */
export async function putApiMenu(
  body: UpdateMenuInput,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>('/api/menu', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
